import React, { Fragment, useEffect, useState } from "react";
import { Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";
import { H5 } from "../../AbstractElements";
import DataTable from "react-data-table-component";
import useAxios from "../../Utils/useAxios";
import {
  dateTimeFieldToDate,
  formatTimestamp,
  getDateToday,
} from "../../Utils/externalFunctions";
import FilterComponent from "../FilterComponents/FilterComponent";
import { filterSearch } from "../../Utils/FilterItems";
import { useThemeContext } from "../../Context/ThemeContext";
import FeatureContainer from "../../Layout/Containers/FeatureContainer";

const SystemLogContain = () => {
  const axiosInstance = useAxios();
  const [systemLogList, setSystemLogList] = useState([]);
  const [pending, setPending] = useState(true);

  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  const { themeContext } = useThemeContext();

  let isMounted = true;
  useEffect(() => {
    getSystemLog();

    return () => {
      isMounted = false;
    };
  }, []);

  const getSystemLog = async () => {
    const response = await axiosInstance.get("system-log/");
    if (response.status === 200 && isMounted) {
      setSystemLogList(response.data);
      setPending(false);
    } else {
      console.error("Error when fetching data");
    }
  };

  const conditionalRowStyles = [
    {
      when: (row) =>
        dateTimeFieldToDate(row.date_modified) === getDateToday("original"),
      style: (row) => ({
        backgroundColor: row.date_modified ? "pink" : "red",
      }),
    },
  ];

  const handleClear = () => {
    if (filterText) {
      setResetPaginationToggle(!resetPaginationToggle);
      setFilterText("");
    }
  };

  const filterSystemLog = (items) => {
    const searchCategories = ["action", "kode", "table", "username"];
    const filteredItems = items.filter(
      filterSearch(searchCategories, filterText)
    );
    return filteredItems;
  };

  const columns = [
    {
      name: "Diajukan oleh",
      selector: (row) => row.username,
    },
    {
      name: "Action",
      selector: (row) => row.action,
      wrap: true,
    },
    {
      name: "Identifier",
      selector: (row) => row.kode,
      wrap: true,
    },
    {
      name: "Tanggal Pembuatan",
      selector: (row) => formatTimestamp(row.date_modified),
    },
  ];

  function MyComponent() {
    return (
      <DataTable
        columns={columns}
        data={filterSystemLog(systemLogList)}
        subHeader
        progressPending={pending}
        subHeaderComponent={
          <FilterComponent
            onFilter={(e) => {
              setFilterText(e.target.value);
            }}
            onClear={() => handleClear()}
            filterText={filterText}
          />
        }
        subHeaderAlign="right"
        conditionalRowStyles={conditionalRowStyles}
        pagination
        theme={themeContext}
      />
    );
  }

  return (
    <FeatureContainer title={"System Log"}>{MyComponent()}</FeatureContainer>
  );
};
export default SystemLogContain;
